const helperHotjar = function (app) {
    const $document = $(document);
    const dataAttr = "data-js-hotjar";
    const selector = `[${dataAttr}]`;

    const init = function () {
        // don't risk registering events more than once a page
        if (!app.hotjarReady) {
            app.hotjarReady = true;
            registerEvents();
        }
    };

    const execEvent = function (eventName) {
        if (!eventName) {
            return { status: "NoEvent" };
        }

        if (window.hj) {
            if (showDebug) {
                console.log(`Hotjar: hj: '${eventName}'`);
            }
            window.hj("event", eventName);
            return { status: "Ok" };
        } else {
            if (showDebug) {
                console.log(`Hotjar: no hj: '${eventName}'`);
            }
            return { status: "NoHj" };
        }
    };

    const registerEvents = function () {
        $document.on("click", selector, function (ev) {
            ev.preventDefault();

            const $elt = $(ev.target).closest(selector);
            execEvent($elt.attr("data-js-hotjar-params"));
        });
    };

    return {
        init: init(),
    };
};

export default helperHotjar;
